import { Button, Form, message, Input, Col, Row, Modal, Select, Switch } from 'antd';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import accountApis from 'api/accountApis';
import orderPaymentApis from 'api/orderPaymentApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat } from 'helpers/dateTimeHelper';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'configs/AppRoutes';

export default function ListAiResellerAccountsPage() {
  const navigate = useNavigate();
  const [passwordForm] = Form.useForm();
  const [orderPaymentForm] = Form.useForm();
  const [isPasswordModalVisible, setIsPasswordModalVisible] = useState(false);
  const [isOrderPaymentModalVisible, setIsOrderPaymentModalVisible] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState(null);

  const [accounts, setAccounts] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [paginate, setPaginate] = useState({});
  const [searchForm] = Form.useForm();

  const showPasswordModal = (id) => {
    setSelectedAccountId(id);
    setIsPasswordModalVisible(true);
  };

  const handleUpdatePassword = async () => {
    try {
      const values = await passwordForm.validateFields();
      const res = await accountApis.updatePassword(selectedAccountId, values);
      if (res.code === 200) {
        message.success('Password updated successfully');
        setIsPasswordModalVisible(false);
        passwordForm.resetFields();
      }
    } catch (error) {
      message.error(error.message || 'Failed to update password');
    }
  };

  async function fetchAccounts(params={}) {
    setIsFetching(true);
    params['from_source'] = 'ai_reseller'
    try {
      const res = await accountApis.listing(params);
      if (res.code === 200) {
        setAccounts(res.data ?? []);
        setPaginate({page: res.page, limit: res.limit, total: res.total})
      }
    } catch (error) {
      message.info(error.message);
    }
    setIsFetching(false);
  }

  useEffect(() => {
    fetchAccounts()
  }, []);

  const onChangeTable = async(pagination, filters, sorter) => {
    console.log(sorter)
    var params = {
      page: pagination.current,
      limit: pagination.pageSize,
      data_sort: sorter.columnKey,
      order_sort: sorter.order
    }
    const args = Object.assign({}, params, searchForm.getFieldsValue())
    await fetchAccounts(args)
  }

  const onFinishSearchForm = async (values) => {
    const params = values || {}
    console.log(params)
    await fetchAccounts(params)
  };

  const handleAccessAccount = async (id) => {
    const res = await accountApis.getLinkAccessAccount(id);
    try {
      const res = await accountApis.getLinkAccessAccount(id);
      if (res.code === 200) {
        window.open(res.access_link,'_blank');
      }
    } catch (error) {
      message.info(error.message);
    }
  };

  const showOrderPaymentModal = (id) => {
    setSelectedAccountId(id);
    setIsOrderPaymentModalVisible(true);
  };

  const handleCreateOrderPayment = async () => {
    try {
      const values = await orderPaymentForm.validateFields();
      Modal.confirm({
        title: 'Confirm Order Payment Creation',
        content: 'Are you sure you want to create this order payment?',
        onOk: async () => {
          const params = {
            account_id: selectedAccountId,
            ...values
          };
          const res = await orderPaymentApis.CreateAndCompletedOrderPayment(params);
          if (res.code === 200) {
            message.success('Order payment created successfully');
            setIsOrderPaymentModalVisible(false);
            orderPaymentForm.resetFields();
            
            // Get current pagination and filter values
            const currentPagination = {
              page: paginate.page,
              limit: paginate.limit
            };
            const currentFilters = searchForm.getFieldsValue();
            
            // Fetch accounts with current pagination and filters
            await fetchAccounts({
              ...currentPagination,
              ...currentFilters
            });
          }
        },
        onCancel() {}
      });
    } catch (error) {
      message.error(error.message || 'Failed to create order payment');
    }
  };

  const handleFeatureToggle = async (feature, checked, record) => {
    try {
      const params = {};
      params.feature = feature
      params.checked = checked
      const res = await accountApis.updateFeatures(record.id, params);
      if (res.code === 200) {
        message.success(`${feature} feature ${checked ? 'enabled' : 'disabled'} successfully`);
        fetchAccounts({
          page: paginate.page,
          limit: paginate.limit,
          ...searchForm.getFieldsValue()
        });
      }
    } catch (error) {
      message.error(error.message || `Failed to update ${feature} feature`);
    }
  };
  

  const bottom = 'bottomRight';

  const columns = [
    {
      title: 'Basic Information',
      width: '30rem',
      render: (record) => (
        <div style={{ whiteSpace: 'pre-line' }}>
          <p><strong>ID:</strong> {record.id}</p>
          <p><strong>Name:</strong> {record.name}</p>
          <p><strong>Email:</strong> {record.email}</p>
          <p><strong>Phone:</strong> {record.phone_number}</p>
          <p><strong>Source:</strong> {record.from_source}</p>
          <p><strong>Store Domain:</strong> {record.store_domain}</p>
          <p><strong>Last Login:</strong> {fullDateTimeFormat(record.last_login_at)}</p>
          <p><strong>Created At:</strong> {fullDateTimeFormat(record.created_at)}</p>
          <p><strong>Status:</strong> {record.status}</p>
          <p><strong>Store Tenant ID:</strong> {record.store_tenant_id}</p>
          {record.current_subscription ? (
            <div style={{ 
              background: '#f5f5f5', 
              borderRadius: '6px', 
              padding: '12px 16px', 
              marginTop: '8px', 
              marginBottom: '8px',
              border: '1px solid #e0e0e0'
            }}>
              <div style={{ marginBottom: '6px', fontWeight: 600, color: '#333' }}>
                Current Subscription
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', fontSize: '14px' }}>
                <span>
                  <strong>Plan Name:</strong> {record.current_subscription.plan_name}
                </span>
                <span>
                  <strong>Status:</strong> {record.current_subscription.status}
                </span>
                <span>
                  <strong>Ngày còn lại:</strong> {record.current_subscription.remaining_days}
                </span>
                <span>
                  <strong>Start Date:</strong> {fullDateTimeFormat(record.current_subscription.start_date)}
                </span>
                <span>
                  <strong>End Date:</strong> {fullDateTimeFormat(record.current_subscription.end_date)}
                </span>
              </div>
            </div>
          ) : (
            <span style={{ color: '#888' }}>No subscription</span>
          )}
        </div>
      )
    },
    {
      title: 'Chức năng',
      width: '15rem',
      render: (record) => (
        <>
          <p>
            <Button type="primary" style={{ width: '170px' }} onClick={() => handleAccessAccount(record.id)}>
              Đăng nhập
            </Button>
          </p>
          <p>
            <Button type="default" style={{ width: '170px' }} onClick={() => showPasswordModal(record.id)}>
              Đổi mật khẩu
            </Button>
          </p>
          {/* <p>
            <Button type="primary" style={{ width: '170px' }} onClick={() => showOrderPaymentModal(record.id)}>
              Create Order Payment
            </Button>
          </p> */}
        </>
      )
    }
  ];
  
  return (
    <>
      {/* <AppHeader
        fixedTop
        pageTitle="Tất cả Accounts Reseller"
        pageHeaderExtras={
          <>
            <Button type="primary" onClick={() => navigate(AppRoutes.Accounts.New.path)}>
              Thêm
            </Button>
          </>
        }
      /> */}
      <br />
      <ContentRow capped>
      <Form
          form={searchForm}
          name="advanced_search"
          className="ant-advanced-search-form"
          onFinish={onFinishSearchForm}
          style={{marginBottom: "40px"}}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name='email'
                label='email'
              >
                <Input placeholder="Tìm theo email" />
              </Form.Item>
            </Col>
            <Col
              style={{
                textAlign: 'right',
              }}
            >
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button
                style={{
                  margin: '0 8px',
                }}
                onClick={() => {
                  searchForm.resetFields();
                  onFinishSearchForm();
                }}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </Form>
        <StyledTable
          sticky={{ offsetHeader: OFFSET_HEADER }}
          size="small"
          scroll={{ x: 1000 }}
          loading={isFetching}
          rowKey="id"
          // @ts-ignore
          columns={columns}
          dataSource={accounts}
          onChange={onChangeTable}
          pagination={{
            defaultPageSize: paginate.limit,
            defaultCurrent: paginate.page,
            total: paginate.total,
            position: [bottom],
            showTotal: (total, range) => (
              <span style={{ left: 0, position: 'absolute' }}>
                Hiển thị {range[0]}-{range[1]} của {total} tin đã đăng
              </span>
            )
          }}
        />
      </ContentRow>
      <Modal
        title="Update Password"
        open={isPasswordModalVisible}
        onOk={handleUpdatePassword}
        onCancel={() => {
          setIsPasswordModalVisible(false);
          passwordForm.resetFields();
        }}
      >
        <Form form={passwordForm}>
          <Form.Item
            name="password"
            label="New Password"
            rules={[{ required: true, message: 'Please input new password!' }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="confirm_password"
            label="Confirm Password"
            dependencies={['password']}
            rules={[
              { required: true, message: 'Please confirm password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Passwords do not match!'));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Create Order Payment"
        open={isOrderPaymentModalVisible}
        onOk={handleCreateOrderPayment}
        onCancel={() => {
          setIsOrderPaymentModalVisible(false);
          orderPaymentForm.resetFields();
        }}
        width={600}
      >
        <div style={{ marginBottom: '24px', padding: '16px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
          <h4 style={{ marginBottom: '12px' }}>Current Subscription</h4>
          {selectedAccountId && accounts.find(acc => acc.id === selectedAccountId)?.current_subscription && (
            <div>
              <p><strong>Plan Name:</strong> {accounts.find(acc => acc.id === selectedAccountId).current_subscription.plan_name}</p>
              <p><strong>Status:</strong> {accounts.find(acc => acc.id === selectedAccountId).current_subscription.status}</p>
              <p><strong>Start Date:</strong> {fullDateTimeFormat(accounts.find(acc => acc.id === selectedAccountId).current_subscription.start_date)}</p>
              <p><strong>End Date:</strong> {fullDateTimeFormat(accounts.find(acc => acc.id === selectedAccountId).current_subscription.end_date)}</p>
            </div>
          )}
        </div>
        <Form form={orderPaymentForm}>
          <Form.Item
            name="plan_id"
            label="Plan ID"
            rules={[{ required: true, message: 'Please select a plan!' }]}
          >
            <Select placeholder="Select a plan">
              <Select.Option value="P11001">PRO 1 tháng</Select.Option>
              <Select.Option value="P11002">PRO 3 tháng</Select.Option>
              <Select.Option value="P11003">PRO 6 tháng</Select.Option>
              <Select.Option value="P11004">PRO 1 năm</Select.Option>
              <Select.Option value="P12001">TEAM 1 tháng</Select.Option>
              <Select.Option value="P12002">TEAM 3 tháng</Select.Option>
              <Select.Option value="P12003">TEAM 6 tháng</Select.Option>
              <Select.Option value="P12004">TEAM 1 năm</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="order_payment_type"
            label="Payment Type"
            rules={[{ required: true, message: 'Please select payment type!' }]}
          >
            <Select>
              <Select.Option value="normal">Đã thanh toán</Select.Option>
              <Select.Option value="free_tier">Được LVB tài trợ</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
